/* Rescuevation · SnakE® Kreisregner-Set Premium (rescu-krp-*), 05.10.2026.

   Bewegung ist ADDITIV: Ohne JavaScript, bei reduzierter Bewegung und wenn ein
   Beobachter nie auslöst, steht jedes Element im fertigen Zustand. Das Skript
   legt nur einmalige Keyframe-Läufe darüber (Klasse krp-go, nach animationend
   wieder entfernt) und lässt Schleifen nur laufen, solange sie zu sehen sind.

   Schutzlinie: Linie ≈ (Anzahl − 1) × Abstand + Wurfkreis. Bedarf für eine
   Länge L: max(3, ceil((L − Wurfkreis) / Abstand) + 1) Regner. Reicht ein Set
   nicht, gewinnt die Kombination mit den wenigsten Sets, bei Gleichstand die
   günstigere.

   Kaufen: Kaufbereich, Planer, Ergänzungen und Kaufleiste legen ihre Artikel
   in einem Aufruf in den Warenkorb (/cart/add.js mit items) und öffnen danach
   Dawns Schublade; ohne Schublade geht es auf die Warenkorbseite. */
(function () {
  'use strict';
  if (window.__rkrp) return;
  window.__rkrp = true;

  var ruhig = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var hatIO = 'IntersectionObserver' in window;
  var alle = function (wurzel, sel) { return Array.prototype.slice.call((wurzel || document).querySelectorAll(sel)); };

  /* ---------- Geld ---------- */

  var zahl = new Intl.NumberFormat('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  function euro(cent) { return zahl.format(Math.round(cent) / 100) + ' €'; }
  function brutto(cent) { return Math.round(cent * 1.19); }

  /* ---------- Daten ---------- */

  var daten = null;
  function ladeDaten() {
    if (daten) return daten;
    var el = document.querySelector('[data-krp-daten]');
    try { daten = JSON.parse(el.textContent); } catch (e) { daten = { varianten: [] }; }
    daten.varianten.sort(function (a, b) { return a.n - b.n; });
    return daten;
  }

  function linieFuer(n, abstand, kreis) { return (n - 1) * abstand + kreis; }

  function plane(laenge, abstand, kreis) {
    var vs = ladeDaten().varianten.filter(function (v) { return v.ok; });
    if (!vs.length) vs = ladeDaten().varianten;
    var bedarf = Math.max(3, Math.ceil((laenge - kreis) / abstand - 1e-9) + 1);
    for (var i = 0; i < vs.length; i++) {
      if (vs[i].n >= bedarf) return { posten: [{ v: vs[i], q: 1 }], n: vs[i].n, preis: vs[i].preis, bedarf: bedarf, kombi: false };
    }
    var groesste = vs[vs.length - 1].n;
    var minSets = Math.ceil(bedarf / groesste);
    var beste = null;
    function suche(start, rest, gewaehlt) {
      if (rest === 0) {
        var n = 0, p = 0;
        gewaehlt.forEach(function (v) { n += v.n; p += v.preis; });
        if (n >= bedarf && (!beste || p < beste.preis)) beste = { liste: gewaehlt.slice(), n: n, preis: p };
        return;
      }
      for (var j = start; j < vs.length; j++) { gewaehlt.push(vs[j]); suche(j, rest - 1, gewaehlt); gewaehlt.pop(); }
    }
    for (var k = minSets; k <= minSets + 2 && !beste; k++) suche(0, k, []);
    var gruppen = [];
    beste.liste.forEach(function (v) {
      var g = gruppen.filter(function (x) { return x.v.id === v.id; })[0];
      if (g) g.q++; else gruppen.push({ v: v, q: 1 });
    });
    gruppen.sort(function (a, b) { return b.v.n - a.v.n; });
    return { posten: gruppen, n: beste.n, preis: beste.preis, bedarf: bedarf, kombi: true };
  }

  function planName(pl) {
    return pl.posten.map(function (p) { return (p.q > 1 ? p.q + ' × ' : '') + p.v.n + 'er-Set'; }).join(' + ');
  }

  /* ---------- Szene ---------- */

  function zeichne(szene, n, neu) {
    var svg = szene.querySelector('[data-krp-svg]');
    if (!svg) return;
    var abstand = parseFloat(svg.getAttribute('data-abstand')) || 12;
    var kreis = parseFloat(svg.getAttribute('data-kreis')) || 28;
    var dyn = svg.querySelector('[data-krp-dyn]');
    if (!szene.__fill) {
      var k0 = dyn.querySelector('.krp-regner__kreis');
      szene.__fill = k0 ? k0.getAttribute('fill') : 'none';
    }
    var linie = linieFuer(n, abstand, kreis);
    var m = Math.max(linie, 110);
    var s = 880 / m;
    var r = kreis * s / 2;
    var breite = linie * s;
    var x0 = 500 - breite / 2;
    var y = 200;
    var f = function (z) { return Math.round(z * 10) / 10; };
    var h = '<line class="krp-szene__schlauch" x1="' + f(x0 + r) + '" y1="' + y + '" x2="' + f(x0 + breite - r) + '" y2="' + y + '"/>';
    for (var i = 0; i < n; i++) {
      var cx = f(x0 + r + i * abstand * s);
      var ax = f(cx + r * 0.9063);
      var ay1 = f(y - r * 0.4226);
      var ay2 = f(y + r * 0.4226);
      h += '<g class="krp-regner" style="--i: ' + i + '">' +
        '<circle class="krp-regner__kreis" cx="' + cx + '" cy="' + y + '" r="' + f(r) + '" fill="' + szene.__fill + '" style="transform-origin: ' + cx + 'px ' + y + 'px"/>' +
        '<path class="krp-regner__strahl" d="M' + cx + ' ' + y + ' L' + ax + ' ' + ay1 + ' A' + f(r) + ' ' + f(r) + ' 0 0 1 ' + ax + ' ' + ay2 + ' Z" style="transform-origin: ' + cx + 'px ' + y + 'px; --d: -' + ((i * 730) % 6000) + 'ms"/>' +
        '<circle class="krp-regner__punkt" cx="' + cx + '" cy="' + y + '" r="6.5"/></g>';
    }
    if (n > 1) {
      var c1 = x0 + r, c2 = c1 + abstand * s;
      h += '<g class="krp-szene__abstand"><line x1="' + f(c1) + '" y1="' + (y - 30) + '" x2="' + f(c2) + '" y2="' + (y - 30) + '"/>' +
        '<text x="' + f((c1 + c2) / 2) + '" y="' + (y - 38) + '" text-anchor="middle">' + abstand + ' m</text></g>';
    }
    h += '<g class="krp-szene__mass"><line x1="' + f(x0) + '" y1="338" x2="' + f(x0 + breite) + '" y2="338"/>' +
      '<line x1="' + f(x0) + '" y1="328" x2="' + f(x0) + '" y2="348"/>' +
      '<line x1="' + f(x0 + breite) + '" y1="328" x2="' + f(x0 + breite) + '" y2="348"/>' +
      '<text x="500" y="370" text-anchor="middle">≈ ' + linie + ' m geschlossene Schutzlinie</text></g>';
    dyn.innerHTML = h;
    var titel = svg.querySelector('[data-krp-svg-titel]');
    if (titel) titel.textContent = 'Draufsicht: ' + n + ' Kreisregner im Abstand von ' + abstand + ' m sichern eine geschlossene Schutzlinie von etwa ' + linie + ' m zwischen Brandfront und Bebauung.';
    if (neu && !ruhig) {
      szene.classList.remove('krp-neu');
      void szene.offsetWidth;
      szene.classList.add('krp-neu');
      clearTimeout(szene.__neuT);
      szene.__neuT = setTimeout(function () { szene.classList.remove('krp-neu'); }, 1800);
    }
  }

  function beobachteSzene(szene) {
    if (!hatIO || ruhig) return;
    new IntersectionObserver(function (es) {
      es.forEach(function (e) { szene.classList.toggle('ist-sichtbar', e.isIntersecting); });
    }, { rootMargin: '80px 0px' }).observe(szene);
  }

  function reglerFuellen(schiene) {
    var min = parseFloat(schiene.min) || 0, max = parseFloat(schiene.max) || 100;
    var p = ((parseFloat(schiene.value) - min) / (max - min)) * 100;
    schiene.style.setProperty('--p', Math.max(0, Math.min(100, p)) + '%');
  }

  function verbindeRegler(wurzel, aufAenderung) {
    var schiene = wurzel.querySelector('[data-krp-laenge]');
    var feld = wurzel.querySelector('[data-krp-laenge-zahl]');
    if (!schiene) return null;
    var min = parseFloat(schiene.min) || 30, max = parseFloat(schiene.max) || 250;
    function setze(wert, quelle) {
      var w = Math.round(Math.max(min, Math.min(max, wert)));
      if (quelle !== 'schiene') schiene.value = w;
      if (quelle !== 'feld' && feld) feld.value = w;
      reglerFuellen(schiene);
      aufAenderung(w, quelle);
    }
    schiene.addEventListener('input', function () { setze(parseFloat(schiene.value), 'schiene'); });
    if (feld) {
      feld.addEventListener('change', function () { var v = parseFloat(feld.value); if (!isNaN(v)) setze(v); });
      feld.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); feld.blur(); var v = parseFloat(feld.value); if (!isNaN(v)) setze(v); } });
    }
    reglerFuellen(schiene);
    return setze;
  }

  /* ---------- Warenkorb ---------- */

  function inDenWarenkorb(items) {
    var schublade = document.querySelector('cart-drawer');
    var body = { items: items };
    if (schublade && typeof schublade.getSectionsToRender === 'function') {
      body.sections = schublade.getSectionsToRender().map(function (s) { return s.id; });
      body.sections_url = window.location.pathname;
    }
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (res) {
      return res.json().then(function (d) {
        if (!res.ok || d.status) throw new Error(d.description || d.message || 'HTTP ' + res.status);
        return d;
      });
    }).then(function (d) {
      if (schublade && typeof schublade.renderContents === 'function' && d.sections) {
        schublade.classList.remove('is-empty');
        schublade.renderContents(d);
      } else {
        window.location.href = root + 'cart';
      }
      return d;
    });
  }

  function knopfLaeuft(btn, an) {
    if (!btn) return;
    if (an) {
      if (!btn.__label) btn.__label = btn.innerHTML;
      btn.setAttribute('aria-busy', 'true');
      btn.classList.add('ist-laeuft');
      btn.style.pointerEvents = 'none';
      var t = btn.querySelector('span:last-child');
      if (t) t.textContent = 'Wird hinzugefügt …';
    } else {
      btn.removeAttribute('aria-busy');
      btn.classList.remove('ist-laeuft');
      btn.style.pointerEvents = '';
      if (btn.__label) btn.innerHTML = btn.__label;
    }
  }
  function knopfOk(btn) {
    if (!btn) return;
    knopfLaeuft(btn, false);
    btn.classList.add('ist-ok');
    var t = btn.querySelector('span:last-child');
    var vorher = t ? t.textContent : '';
    if (t) t.textContent = 'Im Warenkorb';
    setTimeout(function () { btn.classList.remove('ist-ok'); if (t) t.textContent = vorher; if (btn.__label) btn.innerHTML = btn.__label; }, 2200);
  }
  function zeigeFehler(wurzel, text) {
    var f = wurzel && wurzel.querySelector('[data-krp-fehler]');
    if (!f) return;
    f.textContent = text ? 'Das hat nicht geklappt: ' + text + '. Ruf uns gern an: +49 1522 8790057.' : '';
    f.hidden = !text;
  }

  /* ---------- Angebot vorbefüllen ---------- */

  var zustand = { produkt: '', set: null, menge: 1, addons: [], laenge: null, plan: null, linie: null };

  function angebotsText(el) {
    var z = [];
    var name = zustand.produkt || 'SnakE® Kreisregner-Set';
    var quelle = el && el.getAttribute('data-krp-angebot-quelle');
    var produkt = el && el.getAttribute('data-krp-angebot-produkt');
    if (produkt) {
      z.push('Angebot für: ' + produkt);
    } else if (quelle === 'linie' && zustand.linie) {
      var pl = zustand.linie.plan;
      z.push('Angebot für: ' + name + ', ' + planName(pl) + ' (' + pl.n + ' Kreisregner, ≈ ' + zustand.linie.gesichert + ' m Schutzlinie)');
      z.push('Geplante Schutzlinie: ' + zustand.linie.laenge + ' m');
    } else {
      if (zustand.plan && zustand.plan.kombi) {
        z.push('Angebot für: ' + name + ', ' + planName(zustand.plan) + ' (' + zustand.plan.n + ' Kreisregner)');
      } else if (zustand.set) {
        z.push('Angebot für: ' + name + ', ' + (zustand.menge > 1 ? zustand.menge + ' × ' : '') + zustand.set.n + 'er-Set (≈ ' + zustand.set.linie + ' m Schutzlinie)');
      }
      zustand.addons.forEach(function (a) { z.push('Dazu: ' + a); });
      if (zustand.laenge) z.push('Geplante Schutzlinie: ' + zustand.laenge + ' m');
    }
    z.push('Feuerwehr / Ort: ');
    return z.join('\n');
  }
  function fuelleAngebot(el) {
    var form = document.getElementById('ContactForm');
    if (!form) return;
    var feld = form.querySelector('textarea');
    if (!feld) return;
    if (feld.value.trim() === '' || feld.getAttribute('data-krp-auto') === feld.value) {
      feld.value = angebotsText(el);
      feld.setAttribute('data-krp-auto', feld.value);
    }
  }
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('[data-krp-angebot]');
    if (a) fuelleAngebot(a);
  });

  /* ---------- Kaufbereich ---------- */

  function initKauf(kauf) {
    var form = kauf.querySelector('[data-krp-form]');
    if (!form) return;
    var abstand = parseFloat(kauf.getAttribute('data-abstand')) || 12;
    var kreis = parseFloat(kauf.getAttribute('data-kreis')) || 28;
    zustand.produkt = kauf.getAttribute('data-produkt') || '';
    var radios = alle(form, '[data-krp-variante]');
    var addons = alle(form, '[data-krp-addon]');
    var anzahl = form.querySelector('[data-krp-anzahl]');
    var submit = form.querySelector('[data-krp-submit]');
    var preisEl = kauf.querySelector('[data-krp-preis]');
    var bruttoEl = kauf.querySelector('[data-krp-brutto]');
    var summeEl = form.querySelector('[data-krp-summe]');
    var umfangEl = form.querySelector('[data-krp-umfang] span');
    var upsell = form.querySelector('[data-krp-upsell]');
    var kombiBox = form.querySelector('[data-krp-kombi]');
    var planer = kauf.querySelector('[data-krp-planer]');
    var kombi = null;

    function aktiv() { return radios.filter(function (r) { return r.checked; })[0] || radios[0]; }
    function infos(r) {
      return { id: +r.value, n: +r.getAttribute('data-anzahl'), linie: +r.getAttribute('data-linie'), schlaeuche: +r.getAttribute('data-schlaeuche'), preis: +r.getAttribute('data-preis'), ok: r.getAttribute('data-verfuegbar') === 'true' };
    }
    function menge() { return Math.max(1, parseInt(anzahl && anzahl.value, 10) || 1); }

    function setzeBilder(v) {
      alle(kauf, '[data-krp-box]').forEach(function (b) { b.classList.toggle('ist-aktiv', +b.getAttribute('data-krp-box') === v.id); });
      alle(kauf, '[data-krp-chip-linie]').forEach(function (e) { e.textContent = '≈ ' + v.linie + ' m Schutzlinie'; });
      alle(kauf, '[data-krp-chip-anzahl]').forEach(function (e) { e.textContent = v.n + ' Kreisregner'; });
      alle(kauf, '[data-krp-chip-name]').forEach(function (e) { e.textContent = v.n + 'er-Set'; });
    }

    function aktualisiere() {
      var v = infos(aktiv());
      var q = menge();
      var basis = kombi ? kombi.preis : v.preis * (planer ? 1 : 1);
      if (preisEl) preisEl.textContent = euro(basis);
      if (bruttoEl) bruttoEl.textContent = euro(brutto(basis));
      setzeBilder(v);
      if (umfangEl) {
        umfangEl.innerHTML = kombi
          ? 'In den Sets: <strong>' + kombi.n + ' × Kreisregner</strong>, ' + kombi.n + ' × Baumhalterung/Standfuß, ' + (kombi.n - kombi.posten.reduce(function (s, p) { return s + p.q; }, 0)) + ' × 15&nbsp;m D-Schlauch, ' + kombi.posten.reduce(function (s, p) { return s + p.q; }, 0) + ' Euroboxen'
          : 'Im Set: <strong>' + v.n + ' × Kreisregner</strong>, ' + v.n + ' × Baumhalterung/Standfuß, ' + v.schlaeuche + ' × 15&nbsp;m D-Schlauch, Eurobox 60 × 40 × 19&nbsp;cm';
      }
      // Upsell
      if (upsell && !planer) {
        var idx = radios.indexOf(aktiv());
        var naechstes = radios[idx + 1];
        var txt = upsell.querySelector('[data-krp-upsell-text]');
        var btn = upsell.querySelector('[data-krp-upsell-btn]');
        if (naechstes && !naechstes.disabled) {
          var nv = infos(naechstes);
          txt.innerHTML = 'Mehr Reichweite: Das <strong>' + nv.n + 'er-Set</strong> sichert ≈&nbsp;' + nv.linie + '&nbsp;m, <span class="krp-plus">' + (nv.linie - v.linie) + '&nbsp;m mehr</span> für ' + euro(nv.preis - v.preis) + ' Aufpreis.';
          btn.textContent = 'Auf ' + nv.n + 'er-Set wechseln';
          btn.hidden = false;
          btn.onclick = function () { naechstes.checked = true; naechstes.dispatchEvent(new Event('change', { bubbles: true })); stoss(kauf.querySelector('.krp-preis')); };
          upsell.hidden = false;
        } else if (document.querySelector('[data-krp-linie]')) {
          txt.innerHTML = 'Längere Schutzlinie? <strong>Sets lassen sich kombinieren.</strong> Der Planer rechnet Dir die Kombination aus.';
          btn.textContent = 'Zum Planer';
          btn.hidden = false;
          btn.onclick = function () { var z = document.querySelector('[data-krp-linie]'); if (z) z.scrollIntoView({ behavior: ruhig ? 'auto' : 'smooth', block: 'start' }); };
          upsell.hidden = false;
        } else {
          upsell.hidden = true;
        }
      }
      // Summe
      var gewaehlt = addons.filter(function (a) { return a.checked; });
      var setSumme = kombi ? kombi.preis : v.preis * q;
      var summe = setSumme;
      gewaehlt.forEach(function (a) { summe += +a.getAttribute('data-preis'); });
      if (summeEl) {
        if (gewaehlt.length || q > 1 || kombi) {
          summeEl.innerHTML = '<span>' + (kombi ? planName(kombi) : (q > 1 ? q + ' × ' : '') + v.n + 'er-Set') + (gewaehlt.length ? ' + ' + gewaehlt.length + ' Ergänzung' + (gewaehlt.length > 1 ? 'en' : '') : '') + '</span><strong>' + euro(summe) + ' netto</strong><span>' + euro(brutto(summe)) + ' inkl. 19&nbsp;% MwSt.</span>';
          summeEl.hidden = false;
        } else {
          summeEl.hidden = true;
        }
      }
      if (submit) submit.disabled = kombi ? false : !v.ok;
      // Zustand für Kaufleiste und Angebot
      zustand.set = v;
      zustand.menge = kombi ? 1 : q;
      zustand.addons = gewaehlt.map(function (a) { return a.getAttribute('data-titel'); });
      zustand.plan = kombi;
      document.dispatchEvent(new CustomEvent('krp:auswahl', { detail: { v: v, kombi: kombi, menge: q } }));
    }

    radios.forEach(function (r) {
      r.addEventListener('change', function () {
        if (planer && !planer.__intern) {
          // Klick auf eine Karte im Planer: Länge auf die Linie dieses Sets setzen
          kombi = null;
          if (planer.__setze) { planer.__intern = true; planer.__setze(+r.getAttribute('data-linie')); planer.__intern = false; }
        }
        aktualisiere();
        var band = kauf.querySelector('[data-krp-band]');
        var setFig = band && band.querySelector('.krp-galerie__bild--set');
        if (band && setFig && !kauf.classList.contains('krp-kauf--buehne')) band.scrollTo({ left: setFig.offsetLeft, behavior: ruhig ? 'auto' : 'smooth' });
      });
    });
    addons.forEach(function (a) { a.addEventListener('change', aktualisiere); });
    var minus = form.querySelector('[data-krp-minus]'), plus = form.querySelector('[data-krp-plus]');
    if (minus) minus.addEventListener('click', function () { anzahl.value = Math.max(1, menge() - 1); aktualisiere(); });
    if (plus) plus.addEventListener('click', function () { anzahl.value = Math.min(50, menge() + 1); aktualisiere(); });
    if (anzahl) anzahl.addEventListener('change', aktualisiere);

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var items = [];
      if (kombi) kombi.posten.forEach(function (p) { items.push({ id: p.v.id, quantity: p.q }); });
      else items.push({ id: infos(aktiv()).id, quantity: menge() });
      addons.filter(function (a) { return a.checked; }).forEach(function (a) { items.push({ id: +a.value, quantity: 1 }); });
      zeigeFehler(kauf, '');
      knopfLaeuft(submit, true);
      inDenWarenkorb(items).then(function () { knopfOk(submit); }).catch(function (err) { knopfLaeuft(submit, false); zeigeFehler(kauf, err.message); });
    });

    // Galerie
    var band = kauf.querySelector('[data-krp-band]');
    var minis = alle(kauf, '[data-krp-mini]');
    if (band && minis.length) {
      minis.forEach(function (m, i) {
        m.addEventListener('click', function () {
          var ziel = band.children[i];
          if (ziel) band.scrollTo({ left: ziel.offsetLeft, behavior: ruhig ? 'auto' : 'smooth' });
        });
      });
      var t;
      band.addEventListener('scroll', function () {
        clearTimeout(t);
        t = setTimeout(function () {
          var i = Math.round(band.scrollLeft / Math.max(1, band.clientWidth));
          minis.forEach(function (m, j) { m.setAttribute('aria-current', j === i ? 'true' : 'false'); });
        }, 60);
      }, { passive: true });
    }

    // Planer
    if (planer) {
      var szene = planer.querySelector('[data-krp-szene]');
      var text = planer.querySelector('[data-krp-planer-text]');
      beobachteSzene(szene);
      var letzteN = null;
      planer.__setze = verbindeRegler(planer, function (laenge, quelle) {
        var pl = plane(laenge, abstand, kreis);
        if (quelle !== 'init') zustand.laenge = laenge;
        radios.forEach(function (r) {
          var empf = r.closest('.krp-set').querySelector('[data-krp-empf]');
          if (empf) empf.hidden = true;
        });
        if (pl.kombi) {
          kombi = pl;
          if (kombiBox) {
            kombiBox.hidden = false;
            kombiBox.querySelector('[data-krp-kombi-titel]').textContent = 'Für ' + laenge + ' m: ' + planName(pl);
            kombiBox.querySelector('[data-krp-kombi-liste]').innerHTML = pl.posten.map(function (p) {
              return '<li><span>' + p.q + ' × ' + p.v.n + 'er-Set</span><strong>' + euro(p.v.preis * p.q) + '</strong></li>';
            }).join('') + '<li><span>' + pl.n + ' Kreisregner · ≈ ' + linieFuer(pl.n, abstand, kreis) + ' m gesichert</span><strong>' + euro(pl.preis) + '</strong></li>';
          }
          kauf.querySelector('.krp-sets').classList.add('ist-kombi');
          if (text) text.innerHTML = 'Für <strong>' + laenge + ' m</strong> brauchst Du ' + pl.bedarf + ' Regner. Die günstigste Lösung mit den wenigsten Euroboxen: <strong>' + planName(pl) + '</strong>, zusammen ≈ ' + linieFuer(pl.n, abstand, kreis) + ' m. Die Sets kuppelst Du über einen D-Schlauch aneinander.';
        } else {
          kombi = null;
          if (kombiBox) kombiBox.hidden = true;
          kauf.querySelector('.krp-sets').classList.remove('ist-kombi');
          var r = radios.filter(function (x) { return +x.value === pl.posten[0].v.id; })[0];
          if (r) {
            if (!r.checked) { planer.__intern = true; r.checked = true; r.dispatchEvent(new Event('change', { bubbles: true })); planer.__intern = false; }
            var empf = r.closest('.krp-set').querySelector('[data-krp-empf]');
            if (empf) empf.hidden = false;
          }
          if (text) text.innerHTML = 'Für <strong>' + laenge + ' m</strong> reicht das <strong>' + pl.n + 'er-Set</strong>: ' + pl.n + ' Regner sichern ≈ ' + linieFuer(pl.n, abstand, kreis) + ' m geschlossene Linie.';
        }
        if (szene && pl.n !== letzteN) { zeichne(szene, pl.n, letzteN !== null); letzteN = pl.n; }
        aktualisiere();
      });
      var start = parseFloat(planer.getAttribute('data-start')) || 60;
      planer.__setze(start, 'init');
    } else {
      aktualisiere();
    }

    // Auswahl aus dem Planer-Abschnitt übernehmen
    document.addEventListener('krp:waehle', function (e) {
      var id = e.detail && e.detail.id;
      var r = radios.filter(function (x) { return +x.value === id; })[0];
      if (!r) return;
      if (planer && planer.__setze) { planer.__setze(+r.getAttribute('data-linie')); }
      else { r.checked = true; r.dispatchEvent(new Event('change', { bubbles: true })); }
      stoss(kauf.querySelector('.krp-preis'));
    });

    kauf.__kaufeAuswahl = function (btn) {
      var items = [];
      if (kombi) kombi.posten.forEach(function (p) { items.push({ id: p.v.id, quantity: p.q }); });
      else items.push({ id: infos(aktiv()).id, quantity: menge() });
      knopfLaeuft(btn, true);
      return inDenWarenkorb(items).then(function () { knopfOk(btn); }).catch(function () { knopfLaeuft(btn, false); kauf.scrollIntoView({ behavior: ruhig ? 'auto' : 'smooth' }); });
    };
  }

  /* ---------- Planer-Abschnitt ---------- */

  function initLinie(sek) {
    var abstand = parseFloat(sek.getAttribute('data-abstand')) || 12;
    var kreis = parseFloat(sek.getAttribute('data-kreis')) || 28;
    var wMin = parseFloat(sek.getAttribute('data-wasser-min')) || 4;
    var wMax = parseFloat(sek.getAttribute('data-wasser-max')) || 24;
    var aufbau = parseFloat(sek.getAttribute('data-aufbau')) || 2;
    var szene = sek.querySelector('[data-krp-szene]');
    var q = function (s) { return sek.querySelector(s); };
    var kauf = q('[data-krp-empf-kauf]');
    var wahl = q('[data-krp-empf-wahl]');
    var marken = alle(sek, '[data-krp-setze]');
    var aktuell = null, letzteN = null;
    beobachteSzene(szene);

    var setze = verbindeRegler(sek, function (laenge, quelle) {
      var pl = plane(laenge, abstand, kreis);
      aktuell = pl;
      if (quelle !== 'init') zustand.laenge = laenge;
      var gesichert = linieFuer(pl.n, abstand, kreis);
      zustand.linie = { plan: pl, laenge: laenge, gesichert: gesichert };
      q('[data-krp-empf-kicker]').textContent = (pl.kombi ? 'Kombination für ' : 'Passt zu ') + laenge + ' m';
      q('[data-krp-empf-name]').textContent = planName(pl);
      var liste = q('[data-krp-empf-liste]');
      if (pl.kombi) {
        liste.innerHTML = pl.posten.map(function (p) { return '<li><span>' + p.q + ' × ' + p.v.n + 'er-Set</span><strong>' + euro(p.v.preis * p.q) + '</strong></li>'; }).join('');
        liste.hidden = false;
      } else {
        liste.hidden = true;
      }
      q('[data-krp-k-linie]').textContent = '≈ ' + gesichert + ' m';
      q('[data-krp-k-n]').textContent = pl.n;
      q('[data-krp-k-wasser]').textContent = 'ca. ' + (pl.n * wMin) + '–' + (pl.n * wMax) + ' l/min';
      q('[data-krp-k-zeit]').textContent = 'ca. ' + (pl.n * aufbau) + ' min';
      q('[data-krp-empf-preis]').textContent = euro(pl.preis);
      q('[data-krp-empf-label]').textContent = pl.kombi ? 'Kombination in den Warenkorb' : pl.n + 'er-Set in den Warenkorb';
      kauf.setAttribute('data-varianten', pl.posten.map(function (p) { return p.v.id + ':' + p.q; }).join(','));
      if (wahl) wahl.hidden = pl.kombi && !document.querySelector('[data-krp-planer]');
      marken.forEach(function (m) { m.classList.toggle('ist-aktiv', +m.getAttribute('data-krp-setze') === laenge); });
      if (szene && pl.n !== letzteN) { zeichne(szene, pl.n, letzteN !== null); letzteN = pl.n; }
    });
    if (!setze) return;
    marken.forEach(function (m) { m.addEventListener('click', function () { setze(+m.getAttribute('data-krp-setze')); }); });
    var start = parseFloat((q('[data-krp-laenge]') || {}).value) || 60;
    setze(start, 'init');

    kauf.addEventListener('click', function () {
      var items = kauf.getAttribute('data-varianten').split(',').map(function (t) { var p = t.split(':'); return { id: +p[0], quantity: +p[1] }; });
      zeigeFehler(sek, '');
      knopfLaeuft(kauf, true);
      inDenWarenkorb(items).then(function () { knopfOk(kauf); }).catch(function (err) { knopfLaeuft(kauf, false); zeigeFehler(sek, err.message); });
    });
    if (wahl) wahl.addEventListener('click', function () {
      if (!aktuell) return;
      if (!aktuell.kombi) document.dispatchEvent(new CustomEvent('krp:waehle', { detail: { id: aktuell.posten[0].v.id } }));
    });
  }

  /* ---------- Ergänzungen ---------- */

  function initDazu(sek) {
    alle(sek, '[data-krp-add]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        if (btn.getAttribute('aria-disabled') === 'true') return;
        e.preventDefault();
        zeigeFehler(sek, '');
        knopfLaeuft(btn, true);
        inDenWarenkorb([{ id: +btn.getAttribute('data-krp-add'), quantity: 1 }])
          .then(function () { knopfOk(btn); })
          .catch(function (err) { knopfLaeuft(btn, false); zeigeFehler(sek, err.message); });
      });
    });
  }

  /* ---------- Anatomie ---------- */

  function initAnatomie(sek) {
    var punkte = alle(sek, '[data-krp-hotspot]');
    alle(sek, '[data-krp-teil]').forEach(function (li) {
      var nr = li.getAttribute('data-krp-teil');
      var an = function () {
        alle(sek, '.krp-teil.ist-aktiv').forEach(function (x) { x.classList.remove('ist-aktiv'); });
        punkte.forEach(function (p) { p.classList.toggle('ist-aktiv', p.getAttribute('data-krp-hotspot') === nr); });
        li.classList.add('ist-aktiv');
      };
      var aus = function () { li.classList.remove('ist-aktiv'); punkte.forEach(function (p) { p.classList.remove('ist-aktiv'); }); };
      li.addEventListener('mouseenter', an);
      li.addEventListener('focus', an);
      li.addEventListener('mouseleave', aus);
      li.addEventListener('blur', aus);
    });
    if (hatIO && !ruhig) {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          if (!e.isIntersecting) return;
          io.disconnect();
          punkte.forEach(function (p) { einmal(p); });
        });
      }, { threshold: 0.35 });
      var fig = sek.querySelector('.krp-anatomie__figur');
      if (fig) io.observe(fig);
    }
  }

  /* ---------- Kaufleiste ---------- */

  function initSticky(leiste) {
    var kauf = document.querySelector('[data-krp-kauf]');
    if (!kauf || !hatIO) return;
    var kaufImBild = true, formImBild = false;
    var setEl = leiste.querySelector('[data-krp-sticky-set]');
    var preisEl = leiste.querySelector('[data-krp-sticky-preis]');
    var knopf = leiste.querySelector('[data-krp-sticky-kauf]');
    function pruefe() {
      var weiter = kauf.getBoundingClientRect().bottom < 0;
      var zeigen = !kaufImBild && !formImBild && weiter;
      if (zeigen && leiste.hidden) {
        leiste.hidden = false;
        if (!ruhig) { leiste.classList.remove('krp-rein'); void leiste.offsetWidth; leiste.classList.add('krp-rein'); }
      } else if (!zeigen) {
        leiste.hidden = true;
      }
    }
    new IntersectionObserver(function (es) { es.forEach(function (e) { kaufImBild = e.isIntersecting; }); pruefe(); }).observe(kauf);
    var form = document.getElementById('ContactForm');
    if (form) new IntersectionObserver(function (es) { es.forEach(function (e) { formImBild = e.isIntersecting; }); pruefe(); }).observe(form);
    window.addEventListener('scroll', function () { if (!kaufImBild) pruefe(); }, { passive: true });
    document.addEventListener('krp:auswahl', function (e) {
      var d = e.detail;
      if (setEl) setEl.textContent = d.kombi ? planName(d.kombi) : (d.menge > 1 ? d.menge + ' × ' : '') + d.v.n + 'er-Set';
      if (preisEl) preisEl.textContent = euro(d.kombi ? d.kombi.preis : d.v.preis * d.menge);
    });
    if (knopf) knopf.addEventListener('click', function (e) {
      if (typeof kauf.__kaufeAuswahl !== 'function') return;
      e.preventDefault();
      kauf.__kaufeAuswahl(knopf);
    });
  }

  /* ---------- Einblenden (additiv) ---------- */

  function einmal(el) {
    if (ruhig) return;
    el.classList.remove('krp-go');
    void el.offsetWidth;
    el.classList.add('krp-go');
    el.addEventListener('animationend', function weg(e) {
      if (e.target !== el) return;
      el.classList.remove('krp-go');
      el.removeEventListener('animationend', weg);
    });
  }
  function stoss(el) {
    if (!el || ruhig) return;
    el.classList.remove('krp-puls');
    void el.offsetWidth;
    el.classList.add('krp-puls');
  }
  function initEinblenden() {
    if (!hatIO || ruhig) return;
    var vh = window.innerHeight || document.documentElement.clientHeight;
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (!e.isIntersecting) return;
        io.unobserve(e.target);
        einmal(e.target);
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    alle(document, '.krp [data-krp-in]').forEach(function (el) {
      // Was beim Laden schon im Bild steht, bleibt ruhig
      if (el.getBoundingClientRect().top < vh * 0.92) return;
      io.observe(el);
    });
  }

  /* ---------- Start ---------- */

  function start() {
    alle(document, '[data-krp-kauf]').forEach(initKauf);
    alle(document, '[data-krp-linie]').forEach(initLinie);
    alle(document, '.krp-dazu').forEach(initDazu);
    alle(document, '[data-krp-anatomie]').forEach(initAnatomie);
    alle(document, '[data-krp-sticky]').forEach(initSticky);
    initEinblenden();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
